const HabitusPayLogo = ({ 
  variant = "full", 
  className = "" 
}: { 
  variant?: "full" | "icon" | "light";
  className?: string;
}) => {
  // Icon-only version (for favicon or small spaces)
  if (variant === "icon") {
    return (
      <svg 
        viewBox="0 0 80 80" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <rect width="80" height="80" rx="16" fill="#1a2a42"/>
        {/* House roof */}
        <path 
          d="M20 38L40 22L60 38" 
          stroke="white" 
          strokeWidth="4" 
          strokeLinecap="round" 
          strokeLinejoin="round"
          fill="none"
        />
        {/* Pay text */}
        <text 
          x="40" 
          y="56" 
          textAnchor="middle" 
          fill="white" 
          fontSize="18" 
          fontFamily="Inter, system-ui, sans-serif"
          fontWeight="500"
        >
          Pay
        </text>
      </svg>
    );
  }

  // Light version (for dark backgrounds like hero)
  if (variant === "light") {
    return (
      <div className={`flex items-center gap-3 ${className}`}>
        <svg 
          viewBox="0 0 50 50" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
          className="w-10 h-10"
        >
          {/* House roof */}
          <path 
            d="M8 26L25 12L42 26" 
            stroke="white" 
            strokeWidth="3" 
            strokeLinecap="round" 
            strokeLinejoin="round"
            fill="none"
          />
          {/* Pay text */}
          <text 
            x="25" 
            y="42" 
            textAnchor="middle" 
            fill="white" 
            fontSize="12" 
            fontFamily="Inter, system-ui, sans-serif"
            fontWeight="500"
          >
            Pay
          </text>
        </svg>
        <div className="flex flex-col">
          <span className="text-xl font-bold text-white tracking-tight">HabitusPay</span>
          <span className="text-[10px] text-white/60 tracking-[0.2em] uppercase">Fintech Realty</span>
        </div>
      </div>
    );
  }

  // Full version (default - for header on light background)
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <svg 
        viewBox="0 0 44 44" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className="w-10 h-10"
      >
        <rect width="44" height="44" rx="10" fill="#1a2a42"/>
        {/* House roof */}
        <path 
          d="M10 22L22 12L34 22" 
          stroke="white" 
          strokeWidth="2.5" 
          strokeLinecap="round" 
          strokeLinejoin="round"
          fill="none"
        />
        {/* Pay text */}
        <text 
          x="22" 
          y="34" 
          textAnchor="middle" 
          fill="white" 
          fontSize="10" 
          fontFamily="Inter, system-ui, sans-serif"
          fontWeight="500"
        >
          Pay
        </text>
      </svg>
      <span className="text-xl font-semibold text-primary tracking-tight">HabitusPay</span>
    </div>
  );
};

export default HabitusPayLogo;
